import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown, User } from "lucide-react";
import { NAV } from "@/data/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState(null);
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-500 ${
        scrolled || open ? "bg-black/80 backdrop-blur-2xl border-b border-white/10" : "bg-gradient-to-b from-black/70 to-transparent"
      }`}
    >
      <div className="container-lux flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo-official.png" alt="K.O Chef & Catering" className="h-16 md:h-20 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((item) => (
            <div key={item.label} className="relative group">
              <Link
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-1 text-[13px] uppercase tracking-[0.15em] text-white/80 hover:text-gold transition-colors"
              >
                {item.label}
                {item.children && <ChevronDown className="w-3 h-3" />}
              </Link>
              {item.children && (
                <div className="absolute left-0 top-full pt-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                  <div className="bg-[#0b0b0b] border border-white/10 min-w-[240px] py-2">
                    {item.children.map((c) => (
                      <Link
                        key={c.to}
                        to={c.to}
                        data-testid={`nav-sub-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="block px-5 py-3 text-[13px] tracking-wide text-white/70 hover:text-gold hover:bg-white/5 transition-colors"
                      >
                        {c.label}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <Link to="/account" data-testid="nav-account" className="text-white/80 hover:text-gold transition-colors" aria-label="My Account"><User className="w-5 h-5" /></Link>
          <Link to="/request-a-quote" data-testid="nav-quote-btn" className="btn-gold !py-3 !px-6">Request a Quote</Link>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 border-t border-white/10 max-h-[80vh] overflow-y-auto no-scrollbar">
          <div className="container-lux py-4 flex flex-col">
            {NAV.map((item) => (
              <div key={item.label} className="border-b border-white/5">
                <div className="flex items-center justify-between">
                  <Link to={item.to} className="py-4 uppercase text-sm tracking-widest text-white/85" data-testid={`m-nav-${item.label.toLowerCase().replace(/\s+/g,"-")}`}>{item.label}</Link>
                  {item.children && (
                    <button onClick={() => setOpenGroup(openGroup === item.label ? null : item.label)} aria-label="expand"><ChevronDown className={`w-4 h-4 text-gold transition-transform ${openGroup === item.label ? "rotate-180" : ""}`} /></button>
                  )}
                </div>
                {item.children && openGroup === item.label && (
                  <div className="pb-3 pl-4">
                    {item.children.map((c) => (
                      <Link key={c.to} to={c.to} className="block py-2 text-sm text-white/60">{c.label}</Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <button onClick={() => nav("/request-a-quote")} className="btn-gold mt-5" data-testid="m-nav-quote">Request a Quote</button>
            <button onClick={() => nav("/account")} className="btn-outline mt-3" data-testid="m-nav-account">My Account</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
